export default __webpack_public_path__ + "static/media/CITY_SQUARES.e99f9f31.png";